import '@bharatpe/bharat-ui/web/styles.min.css';
import './styles/index.scss';

import React from 'react';
import ReactDOM from 'react-dom';
import { Provider } from 'react-redux';

import ThemeProvider from '@bharatpe/bharat-ui/web/ThemeProvider';

import App from './containers/App';

import store from './store';
import reportWebVitals from './reportWebVitals';
import { initSentry } from './utils/Sentry';
import pjson from '../package.json';
import './i18n';
import 'regenerator-runtime/runtime';
import './polyfill-library';

console.log(`------ Version: ${pjson.version} - Build: ${process.env.NODE_ENV} -----`);

ReactDOM.render(
	<React.StrictMode>
		<ThemeProvider>
			<Provider store={store}>
				<App />
			</Provider>
		</ThemeProvider>
	</React.StrictMode>,
	document.getElementById('root'),
);

// initialized sentry
initSentry();

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
